module.exports = __webpack_public_path__ + "static/media/american-sign-language-interpreting.58ebee59.svg";